// extracted by mini-css-extract-plugin
module.exports = {"actions":"ContentDetailsPage_actions__2oX76"};